import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-marketing-announcement',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    style: 'display: block; width: 100%; max-width: 100%;',
  },
  template: `
    @if (text) {
      <div class="cg-mkt-announcement">
        <div class="cg-mkt-announcement__inner">
          @if (pill) {
            <span class="cg-mkt-announcement__pill">{{ pill }}</span>
          }
          <span class="cg-mkt-announcement__text">{{ text }}</span>
          @if (ctaLabel && ctaHref) {
            <a [href]="ctaHref" class="cg-mkt-announcement__cta">{{ ctaLabel }} →</a>
          }
        </div>
      </div>
    }
  `,
})
export class MarketingAnnouncementComponent {
  @Input() pill?: string;
  @Input() text?: string;
  @Input() ctaLabel?: string;
  @Input() ctaHref?: string;
}
